<template>
    <div class="header">
        <span v-if="!mobileResolution">
            <svg class="header-stroke" width="1441" height="146" viewBox="0 0 1441 146" preserveAspectRatio="none">
                <path d="M422 98L211.5 121L0 111V0H1441V105.5L1036.51 135.5L935.382 84.5L743.247 111L623.921 62L528.865 146L422 98Z" fill="url(#paint0_linear)"/>
                <defs>
                    <linearGradient id="paint0_linear" x1="8.05222e-06" y1="73" x2="1441" y2="73" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#fdd19e"/>
                        <stop offset="0.317708" stop-color="#2CFFFA"/>
                        <stop offset="0.651042" stop-color="#45B0FE"/>
                        <stop offset="1" stop-color="#6D8DFF"/>
                    </linearGradient>
                </defs>
            </svg>
            <svg class="header-back" width="1440" height="146" viewBox="0 0 1440 146" preserveAspectRatio="none">
                <path d="M421 98L210.5 121L-1 111V0H1440V105.5L1035.51 135.5L934.382 84.5L742.247 111L622.921 62L527.865 146L421 98Z" fill="white"/>
            </svg>
        </span>
        <span v-if="mobileResolution">
            <svg class="header-stroke" width="411" height="117" viewBox="0 0 411 117" preserveAspectRatio="none">
                <path d="M164.07 0H65.9151H0V104.5L65.9151 106.5L164.07 93.9999L263 117L344.09 102.5L411 117V0H344.09H263H164.07Z" fill="url(#paint0_linear)"/>
                <defs>
                    <linearGradient id="paint0_linear" x1="2.29664e-06" y1="58.5" x2="411" y2="58.5" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#fdd19e"/>
                        <stop offset="0.317708" stop-color="#2CFFFA"/>
                        <stop offset="0.651042" stop-color="#45B0FE"/>
                        <stop offset="1" stop-color="#6D8DFF"/>
                    </linearGradient>
                </defs>
            </svg>
            <svg class="header-back" width="411" height="117" viewBox="0 0 411 117" preserveAspectRatio="none">
                <path d="M164.07 0H65.9151H0V104.5L65.9151 106.5L164.07 93.9999L263 117L344.09 102.5L411 117V0H344.09H263H164.07Z" fill="white"/>
            </svg>
        </span>
        
        <h1>gregory sawchuk</h1>
        <!-- <div role="button" class="filter-content" :class="{'selected-pro': selectedPro}">
            <p class="btn-text" :class="{'active': selectedPro}" @click="selectedProChanged(true)"><span>p</span>rofessional&nbsp;<span>w</span>ork</p>
            <p class="btn-text" :class="{'active': !selectedPro}" @click="selectedProChanged(false)"><span>p</span>ersonal&nbsp;<span>w</span>ork</p>
        </div> -->
        <div class="btn-ctnr">
            <a class="btn-text" href="resume.pdf" target="_blank"><img src="./../assets/icon_resume.svg"><span>r</span>esume</a>
            <button class="btn-text contact" @click="toggleContactModal()" :class="{'active': contactModalOpen}"><img src="./../assets/icon_contact.svg"><span>c</span>ontact</button>
            <div class="modal modal-contact" :class="{'visible': contactModalOpen}">
                <button aria-label="close contact info" class="modal-close" @click="contactModalOpen = false" :tabindex="contactModalOpen ? 0 : -1">
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L4.5 4.5M8 8L4.5 4.5M4.5 4.5L8 1L1 8" stroke="white" stroke-width="2"/>
                    </svg>
                </button>
                <p class="contact-info" style="pointer-events: none; user-select: none;" tabindex="-1">
                    <span><img src="./../assets/icon_phone.svg"></span>
                    (914) 960 - 7682
                </p>
                <a class="contact-info" href="mailto:gjsawchuk@gmail.com" :tabindex="contactModalOpen ? 0 : -1">
                    <span><img src="./../assets/icon_email.svg"></span>
                    gjsawchuk@gmail.com
                </a>
                <a class="contact-info" href="https://www.linkedin.com/in/gregorysawchuk/" target="_blank" :tabindex="contactModalOpen ? 0 : -1">
                    <span><img src="./../assets/icon_linkedin.svg"></span>
                    LinkedIn
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            contactModalOpen: false,
            mobileResolution: false
        }
    },
    props: ['selectedPro'],
    methods: {
        selectedProChanged(value) {
            this.$emit('selectedProChanged', value);
        },
        toggleContactModal() {
            this.contactModalOpen = !this.contactModalOpen;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            window.innerWidth > 1024 ? this.mobileResolution = false : this.mobileResolution = true;
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped lang="scss">
.header {
    position: fixed;
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    height: 100px;
    padding: 0 70px;
    top: 0;
    z-index: 100;
    .header-back,
    .header-stroke {
        position: absolute;
        left: 1rem;
        top: 0;
        width: calc(100% - 32px); //calc to leave room for content scrollbar
        z-index: -1;
        &.two {
            width: 110%;
            top: -12px;
            display: none;
        }
    }
    .header-stroke {
        top: 1px;
    }
    h1 {
        font-size: 22px;
        font-weight: 900;
        font-variant: small-caps;
        line-height: 17px;
    }
    .filter-content {
        display: flex;
        cursor: pointer;
        position: relative;
        display: none;
        &::after {
            content: '';
            position: absolute;
            width: 122px;
            height: 3px;
            background-color: black;
            bottom: 2px;
            left: 0;
            transition: all 0.2s ease-in-out;
        }
        &:not(.selected-pro) {
            &::after {
                transform: translateX(137px);
                width: 98px;
            }
        }
        p {
            height: 30px;
            padding: 0;
            background-color: white;
            margin-right: 15px;
            color: var(--color-light);
            transition: all 0.2s ease-in-out;
            &:hover {
                color: var(--color-dark);
            }
            &.active {
                color: var(--color-dark);
            }
        }
    }
    .btn-ctnr {
        display: flex;
        margin-left: auto;
        position: relative;
        > button.btn-text, a.btn-text {
            text-decoration: none;
            color: var(--color-dark);
            margin-left: 15px;
            padding: 5px;
            align-items: center;
            > img {
                margin-right: 5px;
                margin-top: 2px;
            }
            &:hover,
            &:focus,
            &.contact.active {
                outline: none;
                > img {
                    animation-name: bounce;
                    animation-duration: 1.2s;
                    animation-iteration-count: infinite;
                    animation-timing-function: ease-in-out;
                    transform: translateY(0);
                }
            }
        }
        .modal.modal-contact {
            top: 35px;
            right: -45px;
            .contact-info {
                margin-bottom: 8px;
                text-decoration: none;
                display: flex;
                align-items: center;
                &:nth-last-child(1) {
                    margin-bottom: 0;
                }
                > span {
                    width: 25px;
                    display: flex;
                    justify-content: center;
                    img {
                        margin-right: 5px;
                    }
                } 
            }
        }
    }
}

@media screen and (max-width: 810px) {
    .header {
        padding: 0 30px;
        .btn-ctnr {
            display: flex;
            margin-left: auto;
            position: relative;
            > button.btn-text, a.btn-text {
                margin-left: 6px !important;
            }
        }
    }
    .modal.modal-contact {
        top: 35px;
        // right: -45px;
        right: 0 !important;
        &::before {
            right: 16% !important;
        }
    }
}

@keyframes bounce {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-3px);
    }
    100% {
        transform: translateY(0);
    }
}
</style>